import { PlayIcon } from "lucide-react";
import type { FC } from "react";
import type { Playable } from "@/lib/audio/playable";
import {
  usePlayablePlaybackState,
  usePlaySoundsAction,
} from "@/lib/audio/use-play-sound";
import { cn } from "@/lib/cn";

export const AudioPlayButton: FC<{
  data: Playable;
  label: string;
  className?: string;
  showLabel?: boolean;
  onPlaybackEnded?: () => void;
  onPlaybackStarted?: (audio: HTMLAudioElement) => void;
}> = ({
  data,
  label,
  className,
  showLabel = false,
  onPlaybackEnded,
  onPlaybackStarted,
}) => {
  const play = usePlaySoundsAction([data]);
  const { isPlaying } = usePlayablePlaybackState(data);

  return (
    <button
      type="button"
      aria-label={label}
      disabled={isPlaying}
      onClick={() => play(onPlaybackEnded, onPlaybackStarted)}
      className={cn(
        "flex h-9 w-full items-center justify-center gap-2 rounded-lg border-2 border-foreground/30 bg-background text-foreground transition-colors duration-200 hover:border-foreground hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/50 disabled:cursor-default motion-reduce:transition-none",
        isPlaying && "border-warning bg-warning/10 text-warning",
        className,
      )}
    >
      <PlayIcon className="h-5 w-5 fill-current" aria-hidden="true" />
      {showLabel && <span className="font-medium text-sm">{label}</span>}
    </button>
  );
};
